<template>
  <div class="pa-3 mb-3" style="border: 1px solid #ccc; border-radius: 4px">
    <v-layout wrap>
      <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('name') }">
        <span>{{ $t('Name') }} </span><span class="red--text">*</span>
        <div class="pt-1">
          <input
            v-model="input.name"
            v-validate="'required'"
            type="text"
            :placeholder="$t('Name')"
            class="form-control"
            maxlength="255"
            :data-vv-as="$t('Name')"
            name="name"
          />
          <span v-if="errors.has('name')" class="text-error">{{ errors.first('name') }}</span>
        </div>
      </v-flex>
      <v-flex xs12 class="form-control" :class="{ 'has-error': errors.has('defaultConsent') }">
        <div class="mb-3">
          <v-checkbox
            v-model="input.default_term_condition"
            color="primary"
            :label="`ใช้เป็นค่าเริ่มต้น`"
          ></v-checkbox>
        </div>
      </v-flex>
      <v-flex xs12 class="form-control pt-2" :class="{ 'has-error': errors.has('TermConditions') }">
        <span class="pb-1">Term & Conditions </span><span class="red--text">*</span>
        <div class="pt-2">
          <vue-editor
            v-model="input.term_condition"
            v-validate="'required'"
            class="custom-editor"
            :data-vv-as="'Term & Conditions'"
            name="TermConditions"
            :editor-toolbar="customToolbar"
          ></vue-editor>
          <span v-if="errors.has('TermConditions')" class="text-error">{{
            errors.first('TermConditions')
          }}</span>
        </div>
      </v-flex>
      <v-flex
        xs12
        sm6
        class="form-control pt-2 pr-1"
        :class="{ 'has-error': errors.has('startTime') }"
      >
        <span class="pb-1">วันที่เริ่มต้น </span><span class="red--text">*</span>
        <DatepickerCustomDialog v-model="input.start_time">
          <template #default="{ computedDate }">
            <v-text-field
              v-validate="'required'"
              class="custom-datepicker-input"
              outline
              name="startTime"
              placeholder="DD/MM/YYYY"
              readonly
              :value="computedDate"
              hide-details
              single-line
              prepend-inner-icon="event"
              style="color: #000"
              :data-vv-as="'วันที่เริ่มต้น'"
            ></v-text-field>
          </template>
        </DatepickerCustomDialog>
        <span v-if="errors.has('startTime')" class="text-error">{{
          errors.first('startTime')
        }}</span>
      </v-flex>
      <v-flex
        xs12
        sm6
        class="form-control pt-2 pl-1"
        :class="{ 'has-error': errors.has('endTime') }"
      >
        <span class="pb-1">วันที่สิ้นสุด </span><span class="red--text">*</span>
        <DatepickerCustomDialog v-model="input.end_time">
          <template #default="{ computedDate }">
            <v-text-field
              v-validate="'required'"
              class="custom-datepicker-input"
              outline
              name="endTime"
              placeholder="DD/MM/YYYY"
              readonly
              :value="computedDate"
              hide-details
              single-line
              prepend-inner-icon="event"
              style="color: #000"
              :data-vv-as="'วันที่สิ้นสุด'"
            ></v-text-field>
          </template>
        </DatepickerCustomDialog>
        <span v-if="errors.has('endTime')" class="text-error">{{ errors.first('endTime') }}</span>
      </v-flex>
      <v-flex xs12 class="pt-3 text-xs-center">
        <v-btn outline color="grey" @click="handleClose">{{ $t('cancel') }}</v-btn>
        <v-btn color="primary" depressed @click="handleSaveData">{{ $t('Save') }}</v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import { VueEditor } from 'vue2-editor'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {
    DatepickerCustomDialog,
    VueEditor
  },
  props: ['value', 'type'],
  data() {
    return {
      input: {
        name: '',
        term_condition: '',
        start_time: '',
        end_time: '',
        default_term_condition: false
      },
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        ['link', 'image']
      ]
    }
  },
  mounted() {
    if (this.value) {
      this.input = this.value
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    moment() {
      return moment
    }
  },
  methods: {
    async handleSaveData() {
      const vm = this

      let result = await vm.$validator.validateAll()
      if (!result) {
        vm.goToErrorInput()
        return false
      }

      let data = {
        name: vm.input.name,
        term_condition: vm.input.term_condition,
        start_time: moment(vm.input.start_time).format('YYYY-MM-DD'),
        end_time: moment(vm.input.end_time).format('YYYY-MM-DD'),
        page_id: vm.selectedBot.pageid,
        default_term_condition: vm.input.default_term_condition
      }

      let response
      if (vm.type === 'add') {
        response = await vm.createTermConditions(data)
      } else {
        Object.assign(data, { id: vm.value.id })
        response = await vm.updateTermConditions(data)
      }

      if (response && response.status === 200) {
        await vm.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        vm.$emit('success')
      }
    },
    async createTermConditions(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.createTermConditions({ config: payload })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    async updateTermConditions(payload) {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.updateTermConditions({ config: payload })
        vm.$store.dispatch('loading')

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
      }
    },
    handleClose() {
      this.input = {
        name: '',
        term_condition: '',
        start_time: '',
        end_time: ''
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/TermsAndConditions/TermsAndConditionsManage.vue